/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusReceiptDto } from './NovitusReceiptDto';
import {
    NovitusReceiptDtoFromJSON,
    NovitusReceiptDtoFromJSONTyped,
    NovitusReceiptDtoToJSON,
} from './NovitusReceiptDto';

/**
 * 
 * @export
 * @interface NovitusReceiptPayloadDto
 */
export interface NovitusReceiptPayloadDto {
    /**
     * Dane paragonu ze wszystkimi wymaganymi polami
     * @type {NovitusReceiptDto}
     * @memberof NovitusReceiptPayloadDto
     */
    receipt: NovitusReceiptDto;
}

/**
 * Check if a given object implements the NovitusReceiptPayloadDto interface.
 */
export function instanceOfNovitusReceiptPayloadDto(value: object): value is NovitusReceiptPayloadDto {
    if (!('receipt' in value) || value['receipt'] === undefined) return false;
    return true;
}

export function NovitusReceiptPayloadDtoFromJSON(json: any): NovitusReceiptPayloadDto {
    return NovitusReceiptPayloadDtoFromJSONTyped(json, false);
}

export function NovitusReceiptPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusReceiptPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'receipt': NovitusReceiptDtoFromJSON(json['receipt']),
    };
}

export function NovitusReceiptPayloadDtoToJSON(value?: NovitusReceiptPayloadDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'receipt': NovitusReceiptDtoToJSON(value['receipt']),
    };
}

